import React from 'react'

import secureImage from '~/public/static/images/svg/secure.svg'

const SecureImage = (props) => {
  return (
      <img src={secureImage} alt="Secure" />
  )
}

export default SecureImage